<template>
    <div class="m-0 p-0">
        <b-dropdown id="dropdown-tools" text="Tools" offset="-40" class="btn btn btn-sm m-0 p-0" variant="primary">
            <template slot="button-content">
                <i class="py-0 fa fa-wrench">&nbsp;</i>
                Tools
            </template>
            <!-- Price Check List-->
            <b-dropdown-item href="/research-checklist">
                <i class="py-0 fa fa-check">&nbsp;</i>
                Price Check List
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <!-- Source Data Links-->
            <b-dropdown-group v-if="urls" id="dropdown-urls" header="Source Data Links">
                <b-dropdown-item v-for="url in urls" v-bind:key="url.text" :href="url.text" target="_blank">
                    <i class="py-0 fa fa-link">&nbsp;</i>
                    {{ formatUrlText(url.text) }}
                </b-dropdown-item>
            </b-dropdown-group>
            <b-dropdown-divider></b-dropdown-divider>
            <!-- Source Data Files-->
            <b-dropdown-group v-if="uploadedFiles" id="dropdown-files" header="Source Data Files">
                <b-dropdown-item v-for="uploadedFile in uploadedFiles" v-bind:key="uploadedFile.id" >
                    <open-media-url :file="uploadedFile">{{ formatFileNameText(uploadedFile.name) }}</open-media-url>
                </b-dropdown-item>
            </b-dropdown-group>
            <b-dropdown-divider></b-dropdown-divider>
            <!-- Research Notes-->
            <b-dropdown-item href="/research-notes">
                <i class="py-0 fa fa-sticky-note">&nbsp;</i>
                Research Notes
            </b-dropdown-item>
            <!-- Confirm Data Check-->
            <b-dropdown-item-button v-b-modal.modal-data-check>
                <i class="py-0 fa fa-certificate">&nbsp;</i>
                Confirm Data Check
            </b-dropdown-item-button>
        </b-dropdown>
    </div>
</template>

<script>
export default {
    name: "ToolsButton",
    props: {
        countryId: {type: String},
        brandId: {type: String},
    },
    data() {
        return {
            urls: [],
            urlDisplayLength: 60,
            uploadedFiles: null,
            fileNameDisplayLength: 45,
        }
    },
    mounted () {
        this.getUrls();
        this.getFiles();
    },
    methods: {
        formatUrlText: function (url) {
            let urlText = url;
            let fromPosition = 0;
            let patterns = ['https://www.', 'https://', 'http://', 'http://www.'];
            for( let i = 0; i < patterns.length; i++) {
                let pos = urlText.search(patterns[i]);
                if (pos === 0) {
                    if (patterns[i].length > fromPosition) {fromPosition = patterns[i].length}
                }
            }
            urlText = urlText.substr(fromPosition, urlText.length)
            if (urlText.length > this.urlDisplayLength) {urlText = urlText.substr(0, this.urlDisplayLength)+'...'}
            return urlText;
        },
        convertToUrlList: function (urlsJson) {
            return urlsJson.map(item => {
                const container = {};
                container['value'] = item.id;
                container['text'] = item.url;
                return container;
            })
        },
        getUrls: function(count) {
            let params = '';
            if (count) {params = '?count='+count}
            axios.get('/api/urls/'+this.countryId+'/' + this.brandId + params)
                .then(response => {
                    this.urlsRetrieved = response.data;
                    this.urls = this.convertToUrlList(response.data);
                })
                .catch(error => {
                    // console.log(error);
                })
        },
        getFiles: function (count) {
            let params = '';
            if (count) {
                params = '?count=' + count
            }
            axios.get('/api/files/' + this.countryId + '/' + this.brandId + params)
                .then(response => {
                    this.uploadedFiles = response.data;
                })
                .catch(error => {
                    // console.log(error);
                })
        },
        formatFileNameText: function (fileName) {
            let text = fileName;
            let fromPosition = 0;
            text = text.substr(fromPosition, text.length)
            if (text.length > this.fileNameDisplayLength) {
                text = text.substr(0, this.fileNameDisplayLength) + '...'
            }
            return text;
        },
        fileFaIcon: function (fileType) {
            let iconClass = '';
            let fileInterjection = 'file-';
            let allowedFileTypes = this.allowedFileTypes();
            if (!allowedFileTypes) {return ''}
            Object.keys(allowedFileTypes).forEach((id, index) => {
                let allowedTypes = allowedFileTypes[id];
                if (allowedTypes.includes(fileType)) {
                    if (id === 'file') {fileInterjection = ''}
                    iconClass = 'fa fa-' + fileInterjection + id;
                }
            });
            return iconClass;
        },
        allowedFileTypes: function () {
            return {
                image: [
                    'image/bmp',
                    'image/gif',
                    'image/jpeg',
                    'image/png',
                    'image/webp',
                    'image/svg+xml',
                ],
                pdf: [
                    'application/pdf',
                ],
                text: [
                    'text/plain',
                ],
                archive: [
                    'application/zip',
                    'application/gzip',
                    'application/vnd.rar',
                    'application/x-tar',
                ],
                excel: [
                    'application/vnd.ms-excel',
                    'application/vnd.oasis.opendocument.spreadsheet',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'text/csv',
                ],
                word: [
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/vnd.oasis.opendocument.text',
                    'application/rtf',
                ],
                powerpoint: [
                    'application/vnd.ms-powerpoint',
                    'application/vnd.oasis.opendocument.presentation',
                    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                ],
                file: [
                    'application/epub+zip',
                ],
            }
        },

    }
}
</script>

<style scoped>

</style>
